/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  night: 'night',
  night_plural: 'night_plural',
  day: 'day',
  day_plural: 'day_plural'
}; export default Keys;